import { Text } from '@qga/roo-ui/components';

import useSearchQuery from '@shared/v2/hooks/useSearchQuery';

import { getOriginName } from '@/v2/utils/getOriginName';

const Departing = ({ routeOriginName }: { routeOriginName?: string }) => {
  const { searchQuery } = useSearchQuery();
  const originName = getOriginName(searchQuery?.originCode) || routeOriginName;

  return originName ? (
    <Text fontSize={['2xs', null, 'sm']} color="greys.steel">
      Departing {originName}
    </Text>
  ) : null;
};

export default Departing;
